export default __webpack_public_path__ + "1ef8b4ffe70ba9aac33918a02bf3cd16.svg";